import axios from "axios";
axios.defaults.withCredentials = true;
import cookie from "js-cookie";
import config from "../config/settings.js";
import apiHelper from "./apiHelper.js";

const loginHelper = {
    forwardUser(link) {
        this.$router.push(link);
    },
    getCookie() {
        let token = cookie.get("XSRF-TOKEN");
        if (token) {
            return new Promise((resolve) => {
                resolve(token);
            });
        } else {
            // return axios.get(this.api + "/csrf-cookie");
            const api = config.API_URL + "/csrf-cookie";
            return apiHelper.getData(api);
        }
    },
    checkLogin(api) {
        return apiHelper.getData(api);
    },
    authUser(api) {
        return apiHelper.getData(api);
    },
}

export default loginHelper;

